import { Splide } from "@splidejs/splide";

document.addEventListener('alpine:init', () => {
    Alpine.data('offersList', () => ({
        filters: [],

        splide: null,
        splideOptions: {
            type: "slide",
            arrows: false,
            fixedWidth: "330px",
            gap: "10px",
            pagination: false,
            mediaQuery: "min",
            breakpoints: {
                767: {
                    destroy: true,
                },
            },
        },
        init() {
            this.splide = new Splide(this.$refs.slider, this.splideOptions).mount().refresh();
            setTimeout(() => this.splide.refresh(), 20);
        },

        shouldShow() {
            return !this.filters.length || this.filters.some(v => this.tags.includes(v))
        },

        refreshSplide() {
            this.splide.refresh();
            this.splide.go(0);
        },
    }));
});
